// API Service
import {apiUrl, templateId, signatureIds} from '../../config';
import Cookies from 'js-cookie';

const SDK_TOKEN_EVENT = 'SDK_TOKEN_UPDATED';
export const CREATE_ESIGN_REQUEST_EVENT = 'CREATE_ESIGN_REQUEST';
const BASE_URL = apiUrl;

const ENDPOINTS = {
  API: 'api',
  SDK: 'sdk-endpoints'
};

const eventEmitter = {
  dispatch: (event, data = {}) => {
    const customEvent = new CustomEvent(event, data);
    window.dispatchEvent(customEvent);
  },
  subscribe: (event, callback) => {
    window.addEventListener(event, callback);
    return () => window.removeEventListener(event, callback);
  }
};

const api = {
  getAuthHeaders: (header,type) => {
    let headerToken;
    headerToken = cookieUtils.get('token');
    if (type === 'SDK') {
      headerToken = cookieUtils.get('sdkToken');
    }
    const defaultHeaders = {
      'Content-Type': 'application/json',
      ...(headerToken && { 'Authorization': `Bearer ${headerToken}` })
    };
    return { ...defaultHeaders};
  },

  createUrl: (endpoint, type = 'API') => {
    const basePath = ENDPOINTS[type] || ENDPOINTS.API;
    return `${BASE_URL}/${basePath}${endpoint}`;
  },

  // HTTP Methods
  get: async (endpoint, type = 'API', headers = {}) => {
    const url = api.createUrl(endpoint, type);
    const response = await fetch(url, {
      method: 'GET',
      headers: api.getAuthHeaders(headers, type)
    });
    return api.handleResponse(response);
  },

  post: async (endpoint, data, type = 'API', headers = {}) => {
    const url = api.createUrl(endpoint, type);
    const response = await fetch(url, {
      method: 'POST',
      headers: api.getAuthHeaders(headers, type),
      body: JSON.stringify(data)
    });
    return api.handleResponse(response);
  },

  put: async (endpoint, data, headers = {}) => {
    const response = await fetch(`${BASE_URL}/${ENDPOINTS.API}${endpoint}`, {
      method: 'PUT',
      headers: api.getAuthHeaders(headers),
      body: JSON.stringify(data)
    });
    return api.handleResponse(response);
  },

  delete: async (endpoint, headers = {}) => {
    const response = await fetch(`${BASE_URL}/${ENDPOINTS.API}${endpoint}`, {
      method: 'DELETE',
      headers: api.getAuthHeaders(headers)
    });
    return api.handleResponse(response);
  },

  // Response handler
  handleResponse: async (response) => {
    if (!response.ok) {
      const error = await response.json().catch(() => ({ message: 'Network error' }));
      throw new Error(error.message || `HTTP error! status: ${response.status}`);
    }
    return response.json();
  },

  // Auth specific methods
  login: (credentials) => api.post('/login', credentials),
  validateAppKeys: async (appKeysData) => {
    const response = await api.post('/generate-session-auth-token', appKeysData, 'SDK');
    if (response.status && response.data?.fesToken) {
      cookieUtils.set('sdkToken', response.data.fesToken, {
        expires: new Date(response.data.expiresAt)
      });
      eventEmitter.dispatch(SDK_TOKEN_EVENT);
    }
    return response;
  },
  
  validateToken: (payload) => api.post('/validate-FES-auth-token', { ...payload }, 'SDK', {
    'Authorization': `Bearer ${payload}`
  }),
  
  // Templates API
  getTemplates: (userId) => api.post(`/gettemplatelist/${userId}`, {
    page: 1,
    per_page: 10,
    search: "",
    sortOrder: "des",
    trash: 0
  }, 'API'),
  
  // eSign API  
  createESignRequests: (name, email, idNumber) => api.post('/create-esign-req',{
    "id":templateId,
    "signatureList":[
        {
            "firstName":name.split(' ')[0],
            "type":"Remote Signer",
            "initials":"",
            "company":"",
            "userid":idNumber,
            "title":"",
            "lastName":name.split(' ')[1] || " ",
            "email":email,
            "signatureId": signatureIds
        }
    ],
    "callbackUrl":`${window.location.origin}/success`,
}, 'SDK')
};

// Cookie utilities
export const cookieUtils = {
  set: (name, value, options = {}) => {
    Cookies.set(name, value, { ...options, path: '/' });
  },
  
  get: (name) => {
    return Cookies.get(name);
  },
  
  delete: () => {
    Object.keys(Cookies.get()).forEach((cookieName) => {
        Cookies.remove(cookieName, { path: '/' }) || 
        Cookies.remove(cookieName, { path: '/dashboard' });
    });
    // Cookies.remove(name, { path: '/' });
    // Cookies.remove(name, { path: '/dashboard' });
  }
};

export { api as default, eventEmitter, SDK_TOKEN_EVENT };